import { CallbackType, StepType } from '@forgerock/javascript-sdk';
import { checkStep } from 'utils/authTree/helpers';
import nextStep from './handleStep';
import successRedirection from './common/successRedirection';
import doItLaterHandlerAsyncAction from './doItLaterHandlerAsyncAction';
import { getCallbackOfTypeSafely, getCallbackWithMessageSafely } from '../authTreeUtils';
import { MESSAGE_ADD_VERIFY_BACKUP_EMAIL } from 'components/Login/constants';

const SKIP_NUMBER = 'skipnumber';

const skipAddNumberAsyncAction = async (dispatch, payload) => {
  const { stage, history, gotoURI, locale, realm, brand } = payload;

  const textOutputCallback = getCallbackOfTypeSafely(stage, CallbackType.TextOutputCallback);
  if (textOutputCallback) {
    const confirmationCallback = stage.getCallbackOfType(CallbackType.ConfirmationCallback);
    confirmationCallback.setInputValue('1');
    const finalStep = await nextStep(dispatch, stage);
    if (finalStep?.type === StepType.LoginSuccess) {
      successRedirection(dispatch, { history, finalStep, gotoURI, locale, realm, brand });
    } else if (getCallbackWithMessageSafely(finalStep, MESSAGE_ADD_VERIFY_BACKUP_EMAIL)) {
      history.push('/addbackupemail');
    } else {
      // handle any uncaught error - request not sent from UI
      checkStep(finalStep, 'D_705');
    }
  }

  const nameCallback = getCallbackOfTypeSafely(stage, CallbackType.NameCallback);
  if (nameCallback) {
    nameCallback.setName(SKIP_NUMBER);
    const secondStep = await nextStep(dispatch, stage);
    if (secondStep && secondStep !== StepType.LoginFailure) {
      doItLaterHandlerAsyncAction(dispatch, { stage: secondStep, history, gotoURI, locale, realm, brand });
    } else {
      // handle any uncaught error - request not sent from UI
      checkStep(secondStep, 'D_705');
    }
  }

  if (!nameCallback && !textOutputCallback) {
    //For any other cases - proceed to doItLater
    doItLaterHandlerAsyncAction(dispatch, { stage, history, gotoURI, locale, realm, brand });
  }
};

export default skipAddNumberAsyncAction;
